import { getPointSymbolLayerConfig } from "@l2r-front/l2r-map"

export function getDocumentItemLayerStyle(attachmentId, road, linearLocationStart, linearLocationEnd) {
    const layerStyle = getPointSymbolLayerConfig({
        layout: {
            "icon-size": 1,
            "icon-image": ["get", "icon", ["properties"]],
        },
    })
    if (attachmentId) {
        layerStyle.filter.push(["==", ["get", "attached_object_uuid", ["properties"]], attachmentId])
    }
    if (linearLocationEnd && linearLocationStart && road) {
        layerStyle.filter.push([
            "all",
            [">=", ["get", "start", ["at", 0, ["get", "linearLocation"]]], parseFloat(linearLocationStart)],
            ["<=", ["get", "end", ["at", 0, ["get", "linearLocation"]]], parseFloat(linearLocationEnd)],
            ["==", ["get", "road", ["at", 0, ["get", "linearLocation"]]], road],
        ])
    }

    return layerStyle
}